import type { ObligationAssessmentResultsByObligationIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationAssessmentResultsByObligationIdArgs = {
  obligationId: string;
};

export const useGetObligationAssessmentResultsByObligationId = createQueryHook<
  UseGetObligationAssessmentResultsByObligationIdArgs,
  ObligationAssessmentResultsByObligationIdResponseRow[],
  GetObligationAssessmentResultsByObligationIdQuery
>({
  trpcQueryOptions: (trpc, { obligationId }) =>
    trpc.frontend.obligationAssessmentResult.obligationAssessmentResultsByObligationId.queryOptions(
      { obligationId }
    ),
  mapTrpcDataToGraphQL: (data) => ({ obligation_assessment_result: data }),
  graphqlDocument: GetObligationAssessmentResultsByObligationIdDocument,
  graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
});
